export { MailPage as default } from '@/components/pages/Ir/Mail'
